<div class="image-upload">
  <div
    *ngFor="let image of images; let i = index"
    class="img-preview-container"
  >
    <div
      style="cursor: pointer"
      class="d-flex align-items-center justify-content-center img-preview{{
        image.status === 'fail' ? '-error' : ''
      }}"
      [style.background-image]=""
      [ngStyle]="{ 'background-image': 'url(&quot;' + image.src + '&quot;)' }"
      (click)="openPreview(image.src)"
    >
      <span
        *ngIf="loading && images.length - 1 == i"
        class="fa fa-spinner fa-spin fa-3x spinner-loading"
      ></span>
    </div>
    <div
      class="remove"
      *ngIf="!loading"
      (click)="removeImage(image.name, i)"
    ></div>
  </div>

  <!-- [2] upload image button -->
  <label
    class="image-upload-container"
    [ngClass]="{ 'is-pending': loading }"
    [class.d-none]="!isMulti && images.length == 1"
  >
    <img src="../../../../assets/img/add-image-icon.svg" />
    <input
      #fileUpload
      [disabled]="loading"
      type="file"
      accept="image/*"
      class="d-none"
      (change)="onUpload($event)"
    />
  </label>
</div>
